import api from "../api";

const api_type = 'v1'

export const GetConfigPage = params => { return api.post(api_type+`/config/page`, params) }
export const ConfigSave = params => { return api.post(api_type+`/config/save`, params) }
export const ConfigDelete = params => { return api.post(api_type+`/config/delete`, params) }

export const GetConfigTypePage = params => { return api.post(api_type+`/config_type/page`, params) }
export const GetConfigTypeAll = params => { return api.post(api_type+`/config_type/all`, params) }
export const ConfigTypeSave = params => { return api.post(api_type+`/config_type/save`, params) }
export const ConfigTypeDelete = params => { return api.post(api_type+`/config_type/delete`, params) }




// WEBPACK FOOTER //
// ./src/api/v1/config_api.js